const RBAC_MAPPING = {
  // Environment
  CREATE_LANDING_ZONE: "Create Landing Zone",
  EDIT_LANDING_ZONE: "Edit Landing Zone",
  CLONE_LANDING_ZONE: "Clone Landing Zone",
  MIGRATE_LANDING_ZONE: "Migrate Landing Zone",
  DELETE_LANDING_ZONE: "Delete Landing Zone",
  REPLICATE_LANDING_ZONE: "Replicate Landing Zone",
  CREATE_PRODUCT_ENCLAVE: "Create Product Enclave",
  EDIT_PRODUCT_ENCLAVE: "Edit Product Enclave",
  CLONE_PRODUCT_ENCLAVE: "Clone Product Enclave",
  MIGRATE_PRODUCT_ENCLAVE: "Migrate Product Enclave",
  DELETE_PRODUCT_ENCLAVE: "Delete Product Enclave",
  REPLICATE_PRODUCT_ENCLAVE: "Replicate Product Enclave",
  ADD_SERVICE_MESH_IN_PRODUCT_ENCLAVE: "Add Service Mesh in Product Enclave",
  EDIT_SERVICE_MESH_IN_PRODUCT_ENCLAVE: "Edit Service Mesh in Product Enclave",
  DELETE_SERVICE_MESH_IN_PRODUCT_ENCLAVE:
    "Delete Service Mesh in Product Enclave",
  ADD_API_GATEWAY_IN_PRODUCT_ENCLAVE: "Add Api Gateway in Product Enclave",
  EDIT_API_GATEWAY_IN_PRODUCT_ENCLAVE: "Edit Api Gateway in Product Enclave",
  DELETE_API_GATEWAY_IN_PRODUCT_ENCLAVE:
    "Delete Api Gateway in Product Enclave",
  ADD_FIREWALL_IN_PRODUCT_ENCLAVE: "Add firewall in Product Enclave",
  EDIT_FIREWALL_IN_PRODUCT_ENCLAVE: "Edit firewall in Product Enclave",
  DELETE_FIREWALL_IN_PRODUCT_ENCLAVE: "Delete firewall in Product Enclave",
  CREATE_CONTAINER_CLUSTER: "Create Container Cluster",
  EDIT_CONTAINER_CLUSTER: "Edit Container Cluster",
  CLONE_CONTAINER_CLUSTER: "Clone Container Cluster",
  MIGRATE_CONTAINER_CLUSTER: "Migrate Container Cluster",
  DELETE_CONTAINER_CLUSTER: "Delete Container Cluster",
  REPLICATE_CONTAINER_CLUSTER: "Replicate Container Cluster",
  // Product
  CREATE_PRODUCT_ENVIRONMENT: "Create Product Environment",
  EDIT_PRODUCT_ENVIRONMENT: "Edit Product Environment",
  CLONE_PRODUCT_ENVIRONMENT: "Clone Product Environment",
  MIGRATE_PRODUCT_ENVIRONMENT: "Migrate Product Environment",
  DELETE_PRODUCT_ENVIRONMENT: "Delete Product Environment",
  REPLICATE_PRODUCT_ENVIRONMENT: "Replicate Product Environment",
  ADD_SERVICE_IN_PRODUCT_ENVIRONMENT: "Add Service in Product Environment",
  EDIT_SERVICE_IN_PRODUCT_ENVIRONMENT: "Edit Service in Product Environment",
  DELETE_SERVICE_IN_PRODUCT_ENVIRONMENT:
    "Delete Service in Product Environment",
  REPLICATE_SERVICE_IN_PRODUCT_ENVIRONMENT:
    "Replicate Service in Product Environment",
  // SRE
  ENABLE_SLA_MONITORING_FOR_SERVICE: "Enable SLA monitoring for Service",
  DISABLE_SLA_MONITORING_FOR_SERVICE: "Disable SLA monitoring for Service",
  ENABLE_LOG_FOR_CLOUD_ELEMENT: "Enable Log for Cloud Element",
  ENABLE_TRACE_FOR_CLOUD_ELEMENT: "Enable Trace for Cloud Element",
  ENABLE_COMPLIANCE_AUDITS_FOR_LANDING_ZONE:
    "Enable compliance audits for Landing Zone",

  // DevSecOps
  GENERATE_SERVICE_FROM_TEMPLATE: "Generate Service from Template",
  PERFORM_CODE_SECURITY_AUDIT_FOR_SERVICE:
    "Perform code security audit for service",
  PERFORM_CODE_SCANNING_FOR_SONAR_COMPLAINCE:
    "Perform code scanning for sonar complaince",
  PERFORM_BDD_TESTS_ON_SERVICE: "Perform bdd tests on service",
  PERFORM_ATP_TESTS_ON_SERVICE: "Perform atp tests on service",
  
  ADD_SERVICE_IN_NON_PROD_PRODUCT_ENVIRONMENT:
    "Add Service in Non-Prod Product Environment",
  EDIT_SERVICE_IN_NON_PROD_PRODUCT_ENVIRONMENT:
    "Edit Service in Non-Prod Product Environment",
  DELETE_SERVICE_IN_NON_PROD_PRODUCT_ENVIRONMENT:
    "Delete Service in Non-Prod Product Environment",
  REPLICATE_SERVICE_IN_NON_PROD_PRODUCT_ENVIRONMENT:
    "Replicate Service in Non-Prod Product Environment",
  ADD_SERVICE_IN_PROD_PRODUCT_ENVIRONMENT:
    "Add Service in Prod Product Environment",
  EDIT_SERVICE_IN_PROD_PRODUCT_ENVIRONMENT:
    "Edit Service in Prod Product Environment",
  DELETE_SERVICE_IN_PROD_PRODUCT_ENVIRONMENT:
    "Delete Service in Prod Product Environment",
  REPLICATE_SERVICE_IN_PROD_PRODUCT_ENVIRONMENT:
    "Replicate Service in Prod Product Environment",
};

export default RBAC_MAPPING;
